/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NzbnCompanyResponseBaseResponse as ModelsCustomerNzbnCompanyResponseBaseResponse } from '../../models/Models/Customer/nzbn-company-response-base-response';

export interface V3CompaniesGet$Xml$Params {

/**
 * The query string eg. "220 Queen Auc"
 */
  query?: string;
}

export function v3CompaniesGet$Xml(http: HttpClient, rootUrl: string, params?: V3CompaniesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CompaniesGet$Xml.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>;
    })
  );
}

v3CompaniesGet$Xml.PATH = '/v3/companies';
